export const NEWSLETTER_SUBSCRIPTION_INFO_KEY = 'NEWSLETTER_SUBSCRIPTION_INFO';

export type SubscriptionStatusesType = 'TRANSITIONAL' | 'SUBSCRIBED' | 'UNSUBSCRIBED' | 'UNKNOWN';

export const SUBSCRIPTION_STATUSES: {[K in SubscriptionStatusesType]: SubscriptionStatusesType} = {
    SUBSCRIBED: 'SUBSCRIBED',
    TRANSITIONAL: 'TRANSITIONAL',
    UNKNOWN: 'UNKNOWN',
    UNSUBSCRIBED: 'UNSUBSCRIBED',
};
